import moment from 'moment';
import _ from 'lodash';

export const serverDateFormat = 'YYYYMMDD';
export const displayDateFormat = 'DD/MM/YYYY';
export const serverTimeFormat = 'HHmmss';
export const displayTimeFormat = 'HH:mm';

export const serverToDate = _.memoize((serverDate) => {
    if (serverDate.length !== serverDateFormat.length) {
        throw 'Invalid date given, date should have exactly 8 characters';
    }

    let parsedDate = moment(serverDate, serverDateFormat);

    if (!parsedDate.isValid()) {
        throw 'This is not a valid date';
    }
    
    return parsedDate;
});

export const serverToTime = _.memoize((serverTime) => {
    if (serverTime.length !== serverTimeFormat.length) {
        throw 'Invalid time given, time should have exactly 6 characters';
    }

    let parsedTime = moment(serverTime, serverTimeFormat);

    if (!parsedTime.isValid()) {
        throw 'This is not a valid time';
    }

    return parsedTime;
});

export const serverToDisplayDate = _.memoize((serverDate) => {
    let parsedDate = serverToDate(serverDate);

    return parsedDate.format(displayDateFormat);
});

export const serverToDisplayTime = _.memoize((serverTime) => {
    let parsedTime = serverToTime(serverTime);

    return parsedTime.format(displayTimeFormat);
});

export const serverToDisplayTimeSlot = (from, to) => {
    return serverToDisplayTime(from) + ' - ' + serverToDisplayTime(to);
};


//////////////////////////////////////////////////////////////////////////////////////


export const displayToServerDate = _.memoize((displayDate) => {
    if (displayDate.length !== displayDateFormat.length) {
        throw 'Invalid date given, date should have exactly 10 characters';
    }

    let parsedDate = moment(displayDate, displayDateFormat);

    if (!parsedDate.isValid()) {
        throw 'This is not a valid date';
    }

    return parsedDate.format(serverDateFormat);
});

export const displayToServerTime = _.memoize((displayTime) => {
    if (displayTime.length !== displayTimeFormat.length) {
        throw 'Invalid time given, time should have exactly 6 characters';
    }

    let parsedTime = moment(displayTime, displayTimeFormat);

    if (!parsedTime.isValid()) {
        throw 'This is not a valid time';
    }

    return parsedTime.format(serverTimeFormat);
});

export const displayToServerTimeSlot = (timeslot) => {
    let fromAndTo = timeslot.split('-');
    return [displayToServerTime(fromAndTo[0].trim()), displayToServerTime(fromAndTo[1].trim())];
};